'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactGoogleMaps = require('react-google-maps');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Note - this must be a class, for some reason,
 * or else the GoogleMaps React component will
 * throw an error with a maximum call stack
 * exceeded from google maps
 */

var _Marker = function (_Component) {
  (0, _inherits3.default)(_Marker, _Component);

  function _Marker() {
    (0, _classCallCheck3.default)(this, _Marker);
    return (0, _possibleConstructorReturn3.default)(this, (_Marker.__proto__ || (0, _getPrototypeOf2.default)(_Marker)).apply(this, arguments));
  }

  (0, _createClass3.default)(_Marker, [{
    key: 'getInfoWindow',
    value: function getInfoWindow() {
      if (this.props.showContent && this.props.children) {
        return _react2.default.createElement(
          _reactGoogleMaps.InfoWindow,
          {
            onCloseclick: function onCloseclick() {}
          },
          this.props.children
        );
      }

      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          lat = _props.lat,
          lng = _props.lng,
          handleClick = _props.handleClick,
          mapHolderRef = _props.mapHolderRef,
          label = _props.label;


      var position = {
        lat: lat,
        lng: lng
      };

      var icon = require('shared/images/number.png');

      return _react2.default.createElement(
        _reactGoogleMaps.Marker,
        {
          position: position,
          onClick: handleClick,
          mapHolderRef: mapHolderRef,
          icon: icon,
          label: label
        },
        this.getInfoWindow()
      );
    }
  }]);
  return _Marker;
}(_react.Component);

exports.default = _Marker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Locations/Marker.jsx
// module id = 1220
// module chunks = 0